import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly _loading = signal<boolean>(false);
  private requestCount = 0;

  /** Observable loading state as signal */
  readonly isLoading = this._loading.asReadonly();

  /** Show the global loader */
  show(): void {
    this.requestCount++;
    this._loading.set(true);
  }

  /** Hide the global loader (only when all requests complete) */
  hide(): void {
    this.requestCount = Math.max(0, this.requestCount - 1);
    if (this.requestCount === 0) {
      this._loading.set(false);
    }
  }

  /** Force hide loader (resets request count) */
  forceHide(): void {
    this.requestCount = 0;
    this._loading.set(false);
  }
}
